import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useTheme } from "../../hooks/";
import { StyledText } from "../../components/common/basic";
import { useHistory } from "react-router-dom";
import TopicCard from "../../screens/subscriber/peerTalk/components/TopicCard";
import YoungsterModal from "../../screens/subscriber/peerTalk/components/YoungsterModal";
import usePeerTalk from "../../screens/subscriber/peerTalk/hooks/usePeerTalk";
import LoadingUI from "../../screens/subscriber/peerTalk/components/LoadingUI";

const PeerTalkView = () => {
  const { themeContext, theme } = useTheme();
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  const { peerTalkData, comments, loading, error } = usePeerTalk();

  const { stories = [] } = peerTalkData || {};

  useEffect(() => {
    // Check local storage to see if the modal has been shown before
    const hasSeenModal = localStorage.getItem("hasSeenYoungsterModal");

    // If not, show the modal and set the flag in local storage
    if (!hasSeenModal) {
      setShowModal(true);
      localStorage.setItem("hasSeenYoungsterModal", "true");
    }
  }, []);

  const handleBackDropClick = () => {
    setShowModal(false);
  };

  return (
    <>
      {showModal && <YoungsterModal onBackDropClick={handleBackDropClick} />}

      <OfferHeader>
        <StyledText style={{ fontSize: "18px", fontWeight: "bold" }}>
          PeerTalk
        </StyledText>
        <ViewAllHolder onClick={() => history.push(`peer_talk`)}>
          <StyledText
            style={{
              fontSize: "14px",
              fontFamily: "MTNRegular",
              margin: "1px 0 0 0",
            }}
            color={background}
          >
            View all
          </StyledText>
        </ViewAllHolder>
      </OfferHeader>

      {loading ? (
        <LoadingUI />
      ) : error ? (
        <StyledText style={{ color: "red" }}>{error}</StyledText>
      ) : (
        <div
          style={{
            maxWidth: "370px",
            margin: "10px auto",
          }}
        >
          {stories.slice(0, 4).map((data, index) => (
            <div style={{ marginBottom: "20px" }}>
              <TopicCard
                key={data._id}
                title={data.title}
                backgroundImage={data.image}
                category={data.category}
                categoryButtonColor={data.color}
                icon={data.icon}
                numberOfComments={data.numberOfComments}
                numberOfViews={data.numberOfViews}
                datePosted={data.createdAt}
                onClick={() =>
                  history.push("/peer_talk/topic_details", {
                    data,
                    comments: comments[data._id] || [],
                  })
                }
              />
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default PeerTalkView;

const OfferHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: 20px;
`;

const ViewAllHolder = styled.div`
  text-align: center;
  cursor: pointer;
`;
